import script from "./SectionTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionTitle.vue?vue&type=script&setup=true&lang=js"

import "./SectionTitle.vue?vue&type=style&index=0&id=27a0b4dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27a0b4dc"]])

export default __exports__